<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-btn slot="activator" dark>New Gateway</v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Test API link gateway/flat to current user</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="title"
                placeholder="Type a name to identify the device"
                :rules="onlyRequiredRule"
                label="Name of the device"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="gateway"
                :rules="onlyRequiredRule"
                label="Gateway ID *"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="flat" :rules="onlyRequiredRule" label="Flat ID *" required></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>

      <transition name="fade">
        <v-card-text v-if="error" class="error-msg">
          <p>{{error}}</p>
        </v-card-text>
      </transition>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  name: 'gateway-new',
  data: () => {
    return {
      onlyRequiredRule: [v => !!v || 'Item is required.'],
      gateway: 'gw-u0000000',
      flat: '100',
      title: '',
      dialog: false,
      error: null
    };
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    save: function() {
      this.$store
        .dispatch('flats/add', {
          flat: this.gateway + '/' + this.flat,
          title: this.title
        })
        .then(() => {
          this.dialog = false;
          this.$router.push('/');
        })
        .catch(e => {
          //segnalare l'errore
          console.log(e.response);
          this.error = e.response.data.message || e;
        });
    }
  }
};
</script>

<style>
</style>
